var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24x24/File_text",
    fill: "#ED145B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.4771525,-2.22044605e-16 4.4408921e-16,4.4771525 0,10 C-4.4408921e-16,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,2.22044605e-16 10,0 Z M10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 C14.418278,2 18,5.581722 18,10 C18,12.1217319 17.1571453,14.1565632 15.6568542,15.6568542 C14.1565632,17.1571453 12.1217319,18 10,18 Z M8.15,5.72 C7.91959209,5.57472389 7.62853225,5.56578786 7.38964624,5.69665584 C7.15076024,5.82752383 7.00160549,6.0776209 7,6.35 L7,13.65 C7.00160549,13.9223791 7.15076024,14.1724762 7.38964624,14.3033442 C7.62853225,14.4342121 7.91959209,14.4252761 8.15,14.28 L14,10.64 C14.2181588,10.5002836 14.350122,10.2590636 14.350122,10 C14.350122,9.74093642 14.2181588,9.49971641 14,9.36 L8.15,5.72 Z",
    id: "icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/Play_Icon.c46c832e72f0307bb1b929b872602c42.svg";
export { ForwardRef as ReactComponent };